import type { TutorFollowAttributes, UserAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type AssociationDefinitions,
  type GroupBy,
  type IncludeAssociations,
  includeAssociationsToSql,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'
import UserQ from './UserQ'

const TutorFollowQ = {
  ...makeQueryModelV2<TutorFollowAttributes>('tutor_follow')([
    'id',
    'user_id',
    'tutor_id',
    'created_at',
  ]),

  associations: (): AssociationDefinitions => ({
    Tutor: { query: UserQ, foreignKey: UserQ.id, sourceKey: TutorFollowQ.tutor_id },
    User: { query: UserQ, foreignKey: UserQ.id, sourceKey: TutorFollowQ.user_id },
  }),

  where: (
    {
      id,
      userId,
      tutorId,
      include = [],
      groupBy = null,
      order = null,
    }: {
      id?: number | SQLFragment<number> | null
      userId?: number | SQLFragment<number> | null
      tutorId?: number | SQLFragment<number> | null
      include?: IncludeAssociations
      groupBy?: GroupBy | null
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<UserAttributes> => SQL`
        FROM ${TutorFollowQ}
        ${includeAssociationsToSql(TutorFollowQ, include)}
        WHERE
            ${id != null ? SQL`${TutorFollowQ.id} = ${id} AND` : SQL``}
            ${userId != null ? SQL`${TutorFollowQ.user_id} = ${userId} AND` : SQL``}
            ${tutorId != null ? SQL`${TutorFollowQ.tutor_id} = ${tutorId} AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
        `,

  getFollowingTutors: (userId: number): SQLFragment<UserAttributes> =>
    TutorFollowQ.where({ userId, include: [{ association: 'Tutor', required: true }] }),
}

export default TutorFollowQ
